import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CDATAConnectorInfo } from '../../../../../../../models/datamodel/adbinfo.model';
import { OAuthService } from '../../../../../../../services/oauth.service';
import { ACDATAConnectorPanel } from '../a.cdata.connector.panel';

@Component({
    selector: 'asana-connector-panel',
    templateUrl: './asana.connector.panel.html'
})
export class AsanaConnectorPanel extends ACDATAConnectorPanel implements OnInit {
    static GetInfo(): CDATAConnectorInfo {
        return {
            Caption: '@@Asana',
            Type: 'evidanza.Database.CData.CDataConnector.ConnectorsInfo.AsanaInfo',
            ControlType: AsanaConnectorPanel,
            Default: {
                AuthType: 0,
                IncludeCustomFields: true,
                Timeout: 60
            }
        };
    }

    RedirectURL: string;

    constructor(private service: OAuthService, private cdRef: ChangeDetectorRef) {
        super();
    }

    ngOnInit(): void {
        // Has to be entered as redirect URL in the Asana app before signing in.
        // The panel is created dynamically and the settings page does not re-render on its own.
        this.service.GetRedirectURL().subscribe(x => {
            this.RedirectURL = x;
            this.cdRef.detectChanges();
        });
    }

    authenticate() {
        if (this.DataSource && this.DataSource.SID) {
            this.service.GetOAuthURL(this.DataSource.SID, 'CData').subscribe(x => {
                if (x) {
                    window.open(x, '_blank');
                }
            });
        }
    }
}
